module.exports = __webpack_public_path__ + "static/matiaswork4-a0b33e60c1b3896e7df97ff155c4263a.jpg";